<template>
  <div>
    <SogCard v-show="_page === 'person'">
      <SogCardTitle> Wählen Sie einen Kontakt aus</SogCardTitle>
      <SogCardActions :is-toolbar="true">
        <SogTextBox
          v-model="_search"
          placeholder="Name"
          :interval-modified="onSearch"
        />
        <SogCardActionButton
          mdi-icon="mdi-magnify"
          style="align-self: flex-end"
          @click="onSearch"
        />
      </SogCardActions>
      <SogCardContent>
        <SogFlexRow>
          <PersonAddressCardComponent
            v-for="item in _lstPerson"
            :key="item"
            :person="item.Person"
            :address="item.Address"
            :allow-select="true"
            @click="onSelectPerson(item)"
          />
        </SogFlexRow>
      </SogCardContent>
    </SogCard>
    <SogCard v-show="_page === 'producttype'">
      <SogCardTitle />
      <SogCardContent>
        <SogFlexColumn>
          <SogButton
            v-show="_hasKzk"
            style="height: 80px; padding: 10px"
            class="full-width"
            @click="onSelectProductType(ProductType.Kzk)"
          >
            Kurzzeitkennzeichen
          </SogButton>
          <SogButton
            v-show="_hasZoll"
            style="height: 80px"
            class="full-width"
            @click="onSelectProductType(ProductType.Zoll)"
          >
            Ausfuhrkennzeichen
          </SogButton>
          <SogButton
            v-show="_hasTz"
            style="height: 80px"
            class="full-width"
            @click="onSelectProductType(ProductType.Tz)"
          >
            Tageszulassung
          </SogButton>
          <SogButton
            v-show="_hasExportBlank"
            style="height: 80px"
            class="full-width"
            @click="onSelectProductType(ProductType.ExportBlank)"
          >
            Ausfuhrversicherungsformulare
          </SogButton>
        </SogFlexColumn>
      </SogCardContent>
    </SogCard>
    <SelectProductComponent v-show="_page==='product'" />
    <ProductPriceComponent v-show="_page === 'productprice'" />
    <StoreExportBlankComponent
      v-show="_page === 'storeexportblank'"
      ref="_storeExportBlank"
    />
    <SogCard v-show="_page === 'store'">
      <SogCardTitle>
        Versicherungskarten
        <template #SubTitle>
          Wählen Sie vorhandene Versicherungskarten aus
        </template>
      </SogCardTitle>
      <SogCardContent v-show="_loadStore">
        <SogSkeleton
          v-for="index in 5"
          :key="index"
          height="48px"
        />
      </SogCardContent>
      <SogCardActions
        v-show="!_loadStore"
        :is-toolbar="true"
      >
        <SogBadge
          v-show="_insurancesCount > 0"
          :value="_insurancesCount"
          badge-style="primary"
          badge-type="notification"
          overlap="true"
        >
          <SogCardActionButton
            v-show="_insurancesCount > 0"
            mdi-icon="mdi-cart-arrow-down"
            tooltip="In den Einkaufswagen legen"
            @click="onAddStore"
          />
        </SogBadge>
        <SogTextBox
          v-model="_insuranceNumberSearch"
          placeholder="Nummer"
          width="150px"
          :interval-modified="p_loadStore"
          style="padding-left: 5px"
        />
        <SogCardActionButton
          :kind="SogButtonKind.Search"
          @click="p_loadStore"
        />
      </SogCardActions>
      <SogCardContent v-show="!_loadStore">
        <SelectInsuranceComponent :insurances="_store" />
      </SogCardContent>
    </SogCard>
    <PremiumComponent v-show="_page === 'premium'" />
    <!--
        <SogCard v-show="_page === 'premium'">
          <SogCardTitle>Prämie/Anzahl</SogCardTitle>
          <SogCardContent>
            <SogForm
              v-show="_current.shoppingCartItem.productPrice?.isStoreExportBlank"
            >
              Anzahl: {{ _current.shoppingCartItem.count }}
            </SogForm>
            <SogForm>
              <SogFormField width="200px">
                <SogNumericTextBox
                  v-show="_current.shoppingCartItem.productPrice?.isJustInTime"
                  ref="_eCount"
                  v-model="_current.shoppingCartItem.count"
                  placeholder="Anzahl"
                  format="n"
                  width="150px"
                  :min="1"
                />
              </SogFormField>
              <SogFormField>
                <SogNumericTextBox
                  v-model="_current.shoppingCartItem.grossPrice"
                  placeholder="Prämie inkl VersSt., €"
                  format="n2"
                  :min="_minPremium"
                  width="150px"
                  :step="0.5"
                />
              </SogFormField>
              <SogFormField v-show="_isInvoiced">
                Abrechnungsbetrag:
                <SogDataLabel
                  :value="_current.shoppingCartItem.amount"
                  :value-type="SogDataLabelValueType.Money"
                />
              </SogFormField>
            </SogForm>
          </SogCardContent>
          <SogCardActions>
            <SogCardActionButton
              mdi-icon="mdi-cart-plus"
              @click="onAddItem"
            >
              In den Einkaufswagen
            </SogCardActionButton>
          </SogCardActions>
        </SogCard>
    -->
    <ExportBlankComponent v-show="_page === 'exportblank'" />
  </div>
</template>

<script setup lang="ts">
import {
  onBeforeRouteUpdate,
  RouteLocationNormalizedLoaded,
  useRoute,
  useRouter,
} from "vue-router";
import {onMounted, reactive, ref, watch} from "vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import SogButton from "@/shared/ui/SogButton.vue";
import {ProductType} from "@/shared/model/productType";
import Product from "@/shared/model/product";
import ProductPrice from "@/shared/model/productPrice";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import ShoppingCartItem from "@/shared/model/shoppingCartItem";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import apiStore from "@/modules/Store/api";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import {computed} from "vue";
import {useAccountStore} from "@/stores/accountStore";
import PersonAddressCardComponent from "@/modules/OrganisationStructure/components/PersonAddressCardComponent.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import Insurance, {sortInsuranceByNumber} from "@/shared/model/Insurance";
import SelectInsuranceComponent from "@/modules/ShoppingCart/components/SelectInsuranceComponent.vue";
import SogBadge from "@/shared/ui/SogBadge.vue";
import SelectProductComponent from "@/modules/ShoppingCart/components/SelectProductComponent.vue";
import PremiumComponent from "@/modules/ShoppingCart/components/PremiumComponent.vue";
import ProductPriceComponent from "@/modules/ShoppingCart/components/ProductPriceComponent.vue";
import StoreExportBlankComponent from "@/modules/ShoppingCart/components/StoreExportBlankComponent.vue";
import ExportBlankComponent from "@/modules/ShoppingCart/components/ExportBlankComponent.vue";
import {storeToRefs} from "pinia";

const _spinner = useSpinner();
const _storeExportBlank = ref<InstanceType<typeof StoreExportBlankComponent> | null>(null)

const _hasKzk = ref(false);
const _hasZoll = ref(false);
const _hasTz = ref(false);
const _hasExportBlank = ref(false);

const _sector = ref("");
const _router = useRouter();
const _page = ref<string | undefined>(undefined);
const _store = ref<Insurance[]>([]);
const _insuranceNumberSearch = ref("");

const _shoppingCartStore = useShoppingCartStore();
const _accountStore = useAccountStore();

const {currentShoppingCart} = storeToRefs(_shoppingCartStore);

/*
const _isInvoiced = computed(()=>{
  const t_invoiceType = ;
  return t_invoiceType!=undefined&&t_invoiceType.indexOf("Invoice")>-1;
})
*/

const _current = ref<{
  baseProducts: Product[];
  productPrices: ProductPrice[];
  shoppingCartItem: ShoppingCartItem;
  baseProductType?: ProductType;
}>({
  baseProducts: [],
  productPrices: [],
  shoppingCartItem: new ShoppingCartItem(),
  baseProductType: undefined,
});

const _eCount = ref<InstanceType<typeof SogNumericTextBox> | null>(null);

const _loadStore = ref(false);
const _search = ref("");
const _lstPerson = reactive<{ Person: Person; Address: Address }[]>([]);

watch(_loadStore, (value) => {
  if (value) {
    _spinner.show();
  } else {
    _spinner.hide();
  }
});


async function onSelectProductType(value: ProductType) {
  await _shoppingCartStore.setProductType(value);
  if (value === ProductType.ExportBlank) {
    await _router.push({path: "add", query: {page: "productprice"}});
  } else {
    await _router.push({path: "add", query: {page: "product"}});
  }
}


async function onAddStore() {
  _current.value.shoppingCartItem.count = _current.value.shoppingCartItem.insurances.length;
  _current.value.shoppingCartItem.grossPrice = _current.value.shoppingCartItem.productPrice?.grossPrice ?? 0;
  await _shoppingCartStore.addItem();
}

async function p_loadStore() {
  _loadStore.value = true;
  try {
    //_storeExportBlank.value = [];
    const price =
      _shoppingCartStore.getCurrentItem().shoppingCartItem.productPrice;
    const lst = await apiStore.listInsurance(
      price,
      price?.grossPrice,
      _insuranceNumberSearch.value
    );
    if (lst) {
      _store.value = sortInsuranceByNumber(
        lst.filter(
          (t) =>
            !_current.value.shoppingCartItem.insurances.some(
              (a) => a.id === t.id
            )
        )
      );
    }
  } finally {
    _loadStore.value = false;
  }
}


async function init(route: RouteLocationNormalizedLoaded) {
  _shoppingCartStore.setSingle(false);
  _spinner.hide();
  _sector.value = route.params.sector as string;
  _page.value = route.query.page as string;
  if (_sector.value === "purchase") {
    if (!_page.value) {
      await _shoppingCartStore.initPurchase();
      _page.value = "producttype";
    }
  } else {
    if (!_page.value) {
      if (!currentShoppingCart.value.personId) {
        _page.value = "person";
      } else {
        _page.value = "producttype";
      }
    }
  }

  _current.value = _shoppingCartStore.getCurrentItem();

  switch (_page.value) {
    case "product":
      if (_current.value.baseProducts.length > 0) {
        break;
      } else {
        await _router.push({path: "add", replace: true});
        return;
      }
    case "productprice":
      if (_current.value.productPrices.length > 0) {
        break;
      } else {
        await _router.push({path: "add", replace: true});
        return;
      }
    case "premium":
      if (_current.value.shoppingCartItem.productPrice) {
        _eCount.value?.focus();
        break;
      } else {
        await _router.push({path: "add", replace: true});
        return;
      }
    case "storeexportblank":
      if (!_current.value.shoppingCartItem.productPrice) {
        await _router.push({path: "add", replace: true});
        return;
      }
      await _storeExportBlank.value?.loadStoreExportBlank();
      break;
    case "exportblank":
      if (!_current.value.shoppingCartItem.productPrice) {
        await _router.push({path: "add", replace: true});
        return;
      }
      break;
    case "store":
      if (!_current.value.shoppingCartItem.productPrice) {
        await _router.push({path: "add", replace: true});
        return;
      }
      await p_loadStore();
      break;
  }

  _hasKzk.value = _shoppingCartStore.hasProductType(ProductType.Kzk);
  _hasZoll.value = _shoppingCartStore.hasProductType(ProductType.Zoll);
  _hasTz.value = _shoppingCartStore.hasProductType(ProductType.Tz);
  _hasExportBlank.value = _shoppingCartStore.hasProductType(
    ProductType.ExportBlank
  );

  /*
    if(sector==="sale") {
      shoppingCart.initSale(personId.value)
    }
  */
}

const _insurancesCount = computed(() => {
  return _current.value.shoppingCartItem.insurances.length;
});

onMounted(async () => {
  const route = useRoute();
  await init(route);
});

onBeforeRouteUpdate(async (to) => {
  await init(to);
});

async function onSearch() {
  const lst = await apiOrganisationStructure.listAddress(
    _accountStore.person?.id ?? "",
    "c+b",
    _search.value
  );
  _lstPerson.length = 0;
  if (lst) {
    _lstPerson.push(...lst);
  }
}

async function onSelectPerson(item: { Person: Person; Address: Address }) {
  await _shoppingCartStore.setSalePerson(item);
  await _router.push({path: "add", query: {page: "producttype"}});
  /*
    copyTo(item.Person,_person)
    copyTo(item.Address,_address)
  */
}

</script>

<style></style>
